/**
 * @title  validateControllervalidateController
 * @author Holger Schauf
 * @type   controller
 * @desc   set validators
 * @date   06.2013
 */
var validateController = (function ($) {
    return Class.extend({
        form: null,
        validateList: [],
        status: true,
        preventSubmitCheck: 'back',
        preventSubmitCheckBackLinkStation: 'backLinkStation',
        submitTrigger: null,
        callback: null,

        init: function (form, cfg, data) {
            this.form = null;
            this.validateList = [];
            this.status = true;

            this.cfg = Object.assign(
                {
                    checkOnSubmit: true,
                    preValidation: true,
                    onError: null,
                    onSuccess: null,
                    callback: null,
                    blockRedirect: false,
                    scrollToError: true,
                },
                cfg
            );

            this.form = form;
            this.data = data.validations;

            this.generateValidation();
            this.bindEvent();

            this.getLocalStorage();
        },

        getLocalStorage: function () {
            if (
                !ApplicationProperties.get('isAppMode') &&
                !ApplicationProperties.get('isLoginActive') &&
                mobile &&
                stj.global.isLocalStorageSupported()
            ) {
                for (var validate in this.data) {
                    var elms = this.data[validate].elms[0].split(', ');
                    if (
                        elms instanceof Array &&
                        this.data[validate].storage !== undefined &&
                        this.data[validate].storage.enabled
                    ) {
                        var elmsLength = elms.length;
                        try {
                            for (var i = 0; i < elmsLength; i++) {
                                var local = stj.global.getLocalStorage(
                                    'personal.' + $(elms[i]).attr('id')
                                );
                                if (local !== null) {
                                    if (
                                        this.data[validate].storage.type ===
                                            'checkbox' ||
                                        this.data[validate].storage.type ===
                                            'radio'
                                    ) {
                                        if (local === 'checked') {
                                            $(elms[i])
                                                .attr('checked', true)
                                                .prop('checked', true);
                                            if (
                                                this.data[validate].storage
                                                    .type === 'radio'
                                            ) {
                                                $(elms[i]).trigger('click');
                                            }
                                        }
                                    } else {
                                        $(elms[i]).val(local);
                                    }
                                }
                            }
                        } catch (e) {}
                    }
                }
            }
        },

        clearLocalStorage: function () {
            if (
                !ApplicationProperties.get('isLoginActive') &&
                mobile &&
                stj.global.isLocalStorageSupported()
            ) {
                try {
                    for (var validate in this.data) {
                        var elms = this.data[validate].elms[0].split(', ');
                        var storage = this.data[validate].storage;
                        if (
                            elms instanceof Array &&
                            storage !== undefined &&
                            storage.enabled
                        ) {
                            var elmsLength = elms.length;
                            for (var i = 0; i < elmsLength; i++) {
                                stj.global.removeLocalStorage(
                                    'personal.' + $(elms[i]).attr('id')
                                );
                            }
                        }
                    }
                } catch (e) {}
            }
        },

        generateValidation: function () {
            for (var validate in this.data) {
                if (this.data[validate].elms instanceof Array) {
                    var elmsLength = this.data[validate].elms.length;
                    for (var i = 0; i < elmsLength; i++) {
                        this.connectValidation(
                            this.data[validate].elms[i],
                            this.data[validate]
                        );
                    }
                }
            }
        },

        /**
         *
         * @param elm
         * @param data
         */
        connectValidation: function (elm, data) {
            if ($(elm).length > 0) {
                data.elm = elm;
                data.cfg = this.cfg;
                this.validateList.push(new validateConnector(data, this.form));
            }
        },

        scrollToFirstError: function () {
            var offer = $('#offer');
            if (offer.length > 0 && typeof offer.data().offer !== 'undefined') {
                var offerClass = offer.data().offer;
                offerClass.button.stop($('#next'));
            }

            var firstError = $(this.form).find('div.error:first');
            var firstErrorParent = firstError.parents('fieldset');

            var scrollToError = mobile ? firstError : firstErrorParent;
            if (scrollToError.length > 0) {
                $('html, body').animate(
                    {
                        scrollTop: scrollToError.offset().top - 15,
                    },
                    500
                );
            }
            return false;
        },

        checkAll: function () {
            this.status = true;

            var validateListLength = this.validateList.length;
            for (var i = 0; i < validateListLength; i++) {
                var validator = this.validateList[i];
                validator.check(true);
                if (validator.status === false) {
                    this.status = validator.status;
                }
            }

            if (this.status === false && this.cfg.scrollToError) {
                this.scrollToFirstError();
            }

            return this.status;
        },

        bindEvent: function () {
            var self = this;

            $('#back, #backLinkStation').on('click', function () {
                self.submitTrigger = $(this);
            });

            this.form.on('submit', $.shove(this.checkSubmit, this));
        },

        checkSubmit: function () {
            if (
                this.submitTrigger === null ||
                (this.submitTrigger.attr('id') !== this.preventSubmitCheck &&
                    this.submitTrigger.attr('id') !==
                        this.preventSubmitCheckBackLinkStation)
            ) {
                this.checkAll();

                if (this.status === false) {
                    var track = new actionTracking({
                        acTrAc: 'pdata_next_error',
                    });
                    track.push();

                    if (this.cfg.onError !== null) {
                        this.cfg.onError();
                    }
                    return false;
                }

                if ($('#borderTraffic').is(':checked')) {
                    new actionTracking({
                        acTrAc: 'crossborder',
                    }).push();
                }

                new actionTracking({
                    acTrAc: 'pdata_next_success',
                }).push();

                if (this.cfg.onSuccess !== null) {
                    return this.cfg.onSuccess();
                }

                if (this.callback !== null) {
                    this.callback();
                }

                if (this.cfg.callback !== null) {
                    this.cfg.callback();
                }

                this.clearLocalStorage();

                return this.cfg.blockRedirect ? false : true;
            }
        },

        changeValidation: function (changeElms) {
            for (var i in this.validateList) {
                if ($.inArray(this.validateList[i].elm, changeElms)) {
                    this.validateList[i].elm.off('change');
                }
            }
        },
    });
})(jQuery);

(function ($) {
    $.fn.directValidate = function (cfg, data) {
        return this.each(function () {
            $(this).data(
                'validate',
                new validateController($(this), cfg, data)
            );
        });
    };
})(jQuery);
